import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
}

export default function Logo({ className = "" }: LogoProps) {
  return (
    <Link
      to="/"
      className={`flex items-center gap-2.5 cursor-pointer shrink-0 ${className}`}
      aria-label="樱桃视频 首页"
    >
      <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
        <i className="ri-movie-2-fill text-xl"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading font-black text-lg tracking-wide text-foreground-950 whitespace-nowrap">
          樱桃视频
        </span>
        <span className="font-label text-[11px] tracking-[0.35em] text-primary-500 mt-0.5">
          CHERRY VIDEO
        </span>
      </span>
    </Link>
  );
}